var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "relative flex items-center w-full gap-4",
      class: { "py-2 border-b border-grey-200": _vm.readOnly },
      attrs: { id: "tasks-codes-item" }
    },
    [
      _vm.kind === "client"
        ? _c(
            "div",
            {
              staticClass:
                "absolute flex items-center justify-center flex-shrink-0 w-10 h-10 text-sm font-medium rounded-full top-2 -left-12 bg-light-purple"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "relative flex flex-col items-center justify-center"
                },
                [
                  _c("BlTextSubtitle2", {
                    staticClass: "text-pure-white",
                    attrs: { text: _vm.index + 1 }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "absolute w-1 transform h-22 top-12 bg-slate-400"
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-full",
          class: {
            "flex flex-col w-full gap-3 p-2 border bg-slate-200 border-slate-400 rounded-xl":
              _vm.kind === "client"
          }
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center w-full gap-3" },
            [
              _vm.kind === "client"
                ? _c("BlSelectBox", {
                    key:
                      "select-" +
                      _vm.code.key +
                      "-" +
                      (_vm.selectBoxKeys[_vm.code.key] || 0),
                    staticClass: "w-32 ",
                    attrs: { type: "branch", options: _vm.codeOptions },
                    on: { change: _vm.onChangeCode },
                    model: {
                      value: _vm.idInput,
                      callback: function($$v) {
                        _vm.idInput = $$v
                      },
                      expression: "idInput"
                    }
                  })
                : _vm.readOnly
                ? _c(
                    "div",
                    {
                      staticClass: "flex items-center flex-shrink-0 w-18 h-11"
                    },
                    [_c("BlTextBody1", { attrs: { text: _vm.code.code } })],
                    1
                  )
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.codeInput,
                        expression: "codeInput"
                      }
                    ],
                    staticClass:
                      "flex-shrink-0 h-10 px-4 text-sm border rounded outline-none w-26 border-grey-200 focus:border-light-purple text-grey",
                    class: { "border-error-400": _vm.errors.code },
                    attrs: { type: "text", placeholder: "Code" },
                    domProps: { value: _vm.codeInput },
                    on: {
                      blur: function($event) {
                        $event.preventDefault()
                        return _vm.onUpdate($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.codeInput = $event.target.value
                      }
                    }
                  }),
              _vm._v(" "),
              _vm.kind === "client"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.codeTitleInput,
                        expression: "codeTitleInput"
                      }
                    ],
                    staticClass:
                      "w-full h-10 px-4 text-sm border rounded outline-none border-grey-200 focus:border-light-purple text-grey",
                    class: { "border-error-400": _vm.errors.title },
                    attrs: { type: "text", placeholder: "Type task title" },
                    domProps: { value: _vm.codeTitleInput },
                    on: {
                      blur: function($event) {
                        $event.preventDefault()
                        return _vm.onUpdate($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.codeTitleInput = $event.target.value
                      }
                    }
                  })
                : _vm.readOnly
                ? _c(
                    "div",
                    { staticClass: "flex items-center w-full h-11" },
                    [
                      _c("BlTextBody1", {
                        attrs: { text: _vm.code.code_definition }
                      })
                    ],
                    1
                  )
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.codeDefinitionInput,
                        expression: "codeDefinitionInput"
                      }
                    ],
                    staticClass:
                      "w-full h-10 px-4 text-sm border rounded outline-none border-grey-200 focus:border-light-purple text-grey",
                    class: { "border-error-400": _vm.errors.codeDefinition },
                    attrs: { type: "text", placeholder: "Code definition" },
                    domProps: { value: _vm.codeDefinitionInput },
                    on: {
                      blur: function($event) {
                        $event.preventDefault()
                        return _vm.onUpdate($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.codeDefinitionInput = $event.target.value
                      }
                    }
                  }),
              _vm._v(" "),
              _c("div", { staticClass: "relative" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "relative flex items-center justify-between h-10 px-4 rounded ",
                    class: [
                      _vm.symbolOpened
                        ? "border-light-purple "
                        : "border-grey-200 ",
                      _vm.readOnly ? "pointer-events-none bg-transparent" : "",
                      _vm.kind === "client"
                        ? " bg-pure-white border-grey-200 w-26"
                        : !_vm.readOnly
                        ? "w-26 bg-pure-white"
                        : "",
                      !_vm.readOnly ? "border" : ""
                    ],
                    attrs: { "data-id": "prompt-symbol-" + _vm.id },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.kind !== "client" &&
                          (_vm.symbolOpened = !_vm.symbolOpened)
                      }
                    }
                  },
                  [
                    _c("div", {
                      class: [
                        _vm.kind !== "client" ? "w-10 h-1" : "w-26 h-1",
                        _vm.readOnly ? "w-15" : ""
                      ],
                      style: { backgroundColor: _vm.colorInput }
                    }),
                    _vm._v(" "),
                    _vm.kind !== "client" && !_vm.readOnly
                      ? _c("BlIcon", {
                          staticClass:
                            "absolute w-5 h-5 transition-all duration-300 right-4",
                          style: _vm.symbolOpened ? "rotate: 180deg" : "",
                          attrs: {
                            "data-id": "prompt-symbol-" + _vm.id,
                            icon: "chevron-down"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.symbolOpened
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "absolute right-0 z-10 w-40 px-2 py-2 mt-2 space-y-4 overflow-y-auto border rounded shadow-md max-h-48 bg-pure-white border-grey-200",
                        attrs: { "data-id": "prompt-symbol-" + _vm.id }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { "data-id": "prompt-symbol-" + _vm.id } },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "grid grid-cols-4 grid-rows-2 gap-3 p-2",
                                attrs: { "data-id": "prompt-symbol-" + _vm.id }
                              },
                              _vm._l(Object.keys(_vm.taskCodeColors), function(
                                color
                              ) {
                                return _c("div", {
                                  key: color,
                                  staticClass:
                                    "flex items-center justify-center w-6 h-6 border-2 rounded cursor-pointer",
                                  class: [
                                    _vm.colorInput ===
                                    _vm.taskCodeColors[color].primaryColor
                                      ? "border-light-purple"
                                      : "border-transparent"
                                  ],
                                  style: {
                                    backgroundColor:
                                      _vm.taskCodeColors[color].primaryColor
                                  },
                                  attrs: {
                                    "data-id": "prompt-symbol-" + _vm.id,
                                    title: color
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.selectColor(
                                        _vm.taskCodeColors[color].primaryColor
                                      )
                                    }
                                  }
                                })
                              }),
                              0
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.kind === "client"
            ? _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.descriptionInput,
                    expression: "descriptionInput"
                  }
                ],
                staticClass:
                  "w-full h-20 px-4 py-3 text-sm border rounded outline-none border-grey-200 focus:border-light-purple text-grey",
                class: { "border-error-400": _vm.errors.description },
                style: { resize: "none" },
                attrs: { placeholder: "Type description" },
                domProps: { value: _vm.descriptionInput },
                on: {
                  blur: function($event) {
                    $event.preventDefault()
                    return _vm.onUpdate($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.descriptionInput = $event.target.value
                  }
                }
              })
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      !_vm.readOnly
        ? _c(
            "div",
            {
              staticClass: "flex items-center cursor-pointer",
              class: [
                _vm.isDeleteDisabled ? "cursor-not-allowed " : "",
                _vm.kind === "client"
                  ? "absolute -right-12 top-2 bg-tomato-100 rounded-full p-2"
                  : ""
              ],
              attrs: { disabled: _vm.isDeleteDisabled },
              on: {
                click: function($event) {
                  !_vm.isDeleteDisabled &&
                    (_vm.kind === "client" ? _vm.onRemove() : _vm.onDelete())
                }
              }
            },
            [
              _c("BlIcon", {
                staticClass: "w-5 h-5",
                attrs: {
                  icon: "delete",
                  color: _vm.isDeleteDisabled ? "grey" : "error",
                  tooltipPosition: _vm.isDeleteDisabled
                    ? _vm.tooltipPosition
                    : "",
                  tooltip: _vm.isDeleteDisabled
                    ? _vm.kind === "client" && _vm.defaultTasks.length <= 1
                      ? "At least one task must remain."
                      : "This code is already associated with targets and cannot be deleted."
                    : ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete the task",
              label: "Delete",
              description:
                "Deleting this code from the repository will only affect new targets going forward. Are you sure you want to proceed? This action is irreversible.",
              type: "error",
              empty: ""
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = false
              },
              "backdrop-action": _vm.onRemove
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47029dda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47029dda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repository/sbt/TasksCodesItem.vue
// module id = null
// module chunks = 